import { render } from "./PBSAlertModal.vue?vue&type=template&id=7d6b363f"
import script from "./PBSAlertModal.vue?vue&type=script&lang=js"
export * from "./PBSAlertModal.vue?vue&type=script&lang=js"

import "./PBSAlertModal.vue?vue&type=style&index=0&id=7d6b363f&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__